import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage, { Section, Champ } from '../components/LegalPage';
import { EDITEUR, PROTECTION_DONNEES, SOUS_TRAITANTS } from '../legalInfo';

export default function SousTraitance() {
  return (
    <LegalPage
      titre="Accord de sous-traitance (RGPD)"
      chapo="Conditions dans lesquelles Jalonne traite, pour le compte de ses entreprises clientes, les données personnelles de leurs propres clients et des tiers. Cet accord répond à l'article 28 du RGPD et fait partie intégrante du contrat d'abonnement."
    >
      <Section titre="1. Qualité des parties">
        <p>
          L'entreprise cliente est <strong>responsable de traitement</strong> : elle décide des
          données qu'elle saisit dans la plateforme et des finalités poursuivies.{' '}
          <Champ valeur={EDITEUR.raisonSociale} attendu="raison sociale" />, éditeur de Jalonne, est{' '}
          <strong>sous-traitant</strong> : elle traite ces données pour le compte du client et sur
          ses instructions documentées.
        </p>
      </Section>

      <Section titre="2. Description du traitement">
        <div className="legal-scroll">
          <table className="legal-table">
            <tbody>
              <tr>
                <th>Objet</th>
                <td>Hébergement et mise à disposition d'une plateforme de suivi de chantier avec pages publiques et notifications</td>
              </tr>
              <tr>
                <th>Durée</th>
                <td>Durée de l'abonnement, augmentée des délais de restitution et de suppression prévus à l'article 9</td>
              </tr>
              <tr>
                <th>Nature des opérations</th>
                <td>Collecte, enregistrement, organisation, conservation, consultation, affichage public, envoi d'emails, extraction, effacement</td>
              </tr>
              <tr>
                <th>Personnes concernées</th>
                <td>Clients et prospects de l'entreprise, personnes abonnées au suivi d'un chantier, intervenants du chantier, personnes éventuellement visibles sur les photographies</td>
              </tr>
              <tr>
                <th>Catégories de données</th>
                <td>Identité (nom), coordonnées (email, téléphone), contenu des messages, images de chantier</td>
              </tr>
              <tr>
                <th>Données sensibles</th>
                <td>Aucune. Le client s'interdit de saisir des données relevant de l'article 9 du RGPD</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Section>

      <Section titre="3. Obligations de Jalonne">
        <p>En qualité de sous-traitant, Jalonne s'engage à :</p>
        <ul>
          <li>ne traiter les données que sur instruction documentée du client, la fourniture du service valant instruction de base ;</li>
          <li>informer le client si une instruction lui paraît constituer une violation du RGPD ;</li>
          <li>garantir la confidentialité des données et n'y donner accès qu'aux personnes habilitées, tenues à une obligation de confidentialité ;</li>
          <li>mettre en œuvre les mesures de sécurité décrites à l'article 5 ;</li>
          <li>ne transférer aucune donnée hors Union européenne sans encadrement juridique approprié ;</li>
          <li>aider le client à répondre aux demandes d'exercice de droits et à ses obligations de sécurité, de notification de violation et d'analyse d'impact ;</li>
          <li>tenir un registre des traitements effectués pour le compte du client.</li>
        </ul>
      </Section>

      <Section titre="4. Obligations du client">
        <p>Le client, responsable de traitement, s'engage à :</p>
        <ul>
          <li>ne saisir que des données pertinentes et nécessaires au suivi du chantier ;</li>
          <li>disposer d'une base légale pour chaque traitement qu'il met en œuvre via la plateforme ;</li>
          <li>informer les personnes concernées, notamment lorsqu'une photographie permet de les identifier, et recueillir leur accord lorsque la loi l'exige ;</li>
          <li>obtenir l'autorisation du maître d'ouvrage lorsque la diffusion publique de l'avancement du chantier la requiert ;</li>
          <li>documenter par écrit toute instruction s'ajoutant à l'usage normal du service ;</li>
          <li>veiller à l'habilitation et au retrait des accès de ses propres utilisateurs.</li>
        </ul>
      </Section>

      <Section titre="5. Mesures de sécurité">
        <p>Jalonne met en œuvre les mesures techniques et organisationnelles suivantes (article 32 du RGPD) :</p>
        <ul>
          <li>chiffrement des communications (HTTPS) ;</li>
          <li>cloisonnement logique strict entre espaces clients, couvert par des tests automatisés d'isolation ;</li>
          <li>authentification par jeton à durée limitée, double authentification disponible et imposable par espace ;</li>
          <li>mots de passe stockés sous forme de condensats non réversibles ;</li>
          <li>journalisation des événements d'authentification et limitation des tentatives ;</li>
          <li>sauvegardes régulières de la base de données et des fichiers ;</li>
          <li>accès aux serveurs restreint aux personnes habilitées.</li>
        </ul>
      </Section>

      <Section titre="6. Sous-traitants ultérieurs">
        <p>
          Le client autorise Jalonne à faire appel aux sous-traitants ultérieurs suivants. Jalonne
          l'informe de tout ajout ou remplacement au moins trente (30) jours à l'avance ; le client
          peut s'y opposer par écrit dans ce délai, l'opposition ouvrant droit à résiliation sans
          frais si aucune alternative n'est trouvée.
        </p>
        <div className="legal-scroll">
          <table className="legal-table">
            <thead>
              <tr><th>Sous-traitant</th><th>Prestation</th><th>Localisation</th></tr>
            </thead>
            <tbody>
              {SOUS_TRAITANTS.map((s, i) => (
                <tr key={i}>
                  <td><Champ valeur={s.nom} attendu="nom du prestataire" /></td>
                  <td>{s.role}</td>
                  <td><Champ valeur={s.localisation} attendu="localisation des serveurs" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>

      <Section titre="7. Violation de données">
        <p>
          Jalonne notifie au client toute violation de données à caractère personnel dans les
          meilleurs délais et au plus tard <strong>48 heures</strong> après en avoir pris
          connaissance, en précisant la nature de la violation, les catégories et le nombre
          approximatif de personnes et d'enregistrements concernés, les conséquences probables et
          les mesures prises. Il appartient au client, responsable de traitement, de procéder le cas
          échéant à la notification à la CNIL dans les 72 heures.
        </p>
      </Section>

      <Section titre="8. Assistance et droits des personnes">
        <p>
          Lorsqu'une personne concernée exerce ses droits directement auprès de Jalonne, la demande
          est transmise au client sans délai et sans y être donné suite, sauf instruction contraire.
          Jalonne fournit au client les moyens techniques de répondre : consultation, rectification
          et suppression des données depuis l'interface, et export complet de l'espace.
        </p>
      </Section>

      <Section titre="9. Sort des données en fin de contrat">
        <p>
          À l'issue du contrat, le client peut exporter l'intégralité de ses données depuis son
          espace, sous la forme d'une archive contenant ses données structurées et ses
          photographies. Les données sont ensuite conservées <strong>trente (30) jours</strong> puis
          supprimées définitivement, copies comprises, sous réserve des conservations imposées par
          la loi. La suppression immédiate peut être déclenchée à tout moment par le client depuis
          son espace.
        </p>
      </Section>

      <Section titre="10. Audit">
        <p>
          Jalonne met à disposition du client, sur demande écrite, les informations nécessaires pour
          démontrer le respect de l'article 28 du RGPD. Le client peut réaliser un audit, au maximum
          une fois par an, sous préavis de trente (30) jours, à ses frais et sans perturber
          l'exploitation du service.
        </p>
      </Section>

      <Section titre="11. Contact">
        <p>
          Toute question relative au présent accord est adressée à{' '}
          <Champ valeur={PROTECTION_DONNEES.contactEmail} attendu="email dédié aux demandes RGPD" />.
          Les traitements pour lesquels Jalonne agit en qualité de responsable sont décrits dans la{' '}
          <Link to="/confidentialite">politique de confidentialité</Link>.
        </p>
      </Section>
    </LegalPage>
  );
}
